import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import CartItem from '../CartItem'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import Text from 'components/common/Text/Text'
import Button from 'components/common/Button/Button'
import { A } from 'components/common/Link/Link'
import { SERVICES_PAGE } from 'constant'

const EmptyQuoteMessage = ({
  handleTireSearch
}) =>
  <Wrapper data-at-quote-empty>
    <Media.Desktop>
      <CartItem />
    </Media.Desktop>
    <MessageTxt>
      <EmptyCartTxt headline>Empty Cart</EmptyCartTxt>
      Your shopping cart is currently empty.
      {
        <ButtonWrapper>
          <StyledButton
            narrow
            onClick={ handleTireSearch }>
            Shop Tires
          </StyledButton>
          <StyledLink
            button
            href={ SERVICES_PAGE } >
            Shop Services
          </StyledLink>
        </ButtonWrapper>
      }
    </MessageTxt>
  </Wrapper>

EmptyQuoteMessage.propTypes = {
  handleTireSearch: PropTypes.func
}

export default EmptyQuoteMessage

const Wrapper = styled.div`
  border: 1px solid ${Theme.colors.light_grey};
`

const MessageTxt = styled.div`
  text-align: center;
  ${Mixin.responsive('margin', '80px 0', '40px 0')}
`

const EmptyCartTxt = styled(Text)`
  font-size: 20px;
  margin-bottom: 5px;
`

const ButtonWrapper = styled.div`
  ${Mixin.responsive('margin', '25px 0', '30px 0')}
  ${Media.mobile`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
  `}
  *:first-child {
    ${Media.desktop`
      margin-right: 10px;
    `}
    ${Media.mobile`
      margin-bottom: 15px;
    `}
  }
`

const StyledButton = styled(Button)`
  ${Media.mobile`
    width: 150px;
    margin-right: 15px;
  `}
`
const StyledLink = styled(A)`
  ${Media.mobile`
    display: block;
    width: 150px;
    padding: 7px 14px 8px;
  `}
`
